// ─── STORE.JS — shared state via localStorage ───────────────────────────────

export const uid = () => Math.random().toString(36).slice(2, 10);

export const LABEL_COLORS = {
  red:    { bg: "#f87168", text: "#fff" },
  orange: { bg: "#faa53d", text: "#fff" },
  yellow: { bg: "#e2b203", text: "#fff" },
  green:  { bg: "#4bce97", text: "#fff" },
  blue:   { bg: "#579dff", text: "#fff" },
  purple: { bg: "#9f8fef", text: "#fff" },
  gray:   { bg: "#8590a2", text: "#fff" },
};

export const LABEL_NAMES = {
  red:    "Urgent",
  orange: "Bug",
  yellow: "Low Priority",
  green:  "Done",
  blue:   "Feature",
  purple: "Design",
  gray:   "Misc",
};

export const DEFAULT_COLUMNS = [
  { id: "col-1", title: "To Do",       color: "#579dff" },
  { id: "col-2", title: "In Progress", color: "#f5a623" },
  { id: "col-3", title: "In Review",   color: "#a78bfa" },
  { id: "col-4", title: "Done",        color: "#4bce97" },
];

export const DEFAULT_CARDS = [
  {
    id: "c1", colId: "col-1",
    title: "Set up project structure",
    desc: "Initialize repo, install deps, configure eslint & prettier",
    labels: ["blue"],
    checklist: [
      { id: "ch1", text: "Create repo", done: true },
      { id: "ch2", text: "Install dependencies", done: true },
      { id: "ch3", text: "Configure ESLint", done: false },
    ],
    archived: false, createdAt: Date.now() - 86400000 * 3,
  },
  {
    id: "c2", colId: "col-1",
    title: "Design database schema",
    desc: "", labels: ["orange"], checklist: [],
    archived: false, createdAt: Date.now() - 86400000 * 2,
  },
  {
    id: "c3", colId: "col-2",
    title: "Build authentication module",
    desc: "JWT-based auth with refresh tokens",
    labels: ["red"],
    checklist: [
      { id: "ch4", text: "Login endpoint",      done: true },
      { id: "ch5", text: "Register endpoint",   done: true },
      { id: "ch6", text: "JWT middleware",       done: false },
      { id: "ch7", text: "Refresh token logic",  done: false },
    ],
    archived: false, createdAt: Date.now() - 86400000,
  },
  {
    id: "c4", colId: "col-2",
    title: "Create helpdesk ticket form",
    desc: "Form with file upload support",
    labels: ["green", "blue"],
    checklist: [
      { id: "ch8", text: "Form fields", done: true },
      { id: "ch9", text: "File upload",  done: false },
    ],
    archived: false, createdAt: Date.now() - 3600000 * 5,
  },
  {
    id: "c5", colId: "col-3",
    title: "Agent dashboard UI",
    desc: "Priority queue view for agents",
    labels: ["purple"],
    checklist: [
      { id: "ch10", text: "Queue component",  done: true },
      { id: "ch11", text: "Priority sorting", done: true },
      { id: "ch12", text: "Assign to agent",  done: true },
    ],
    archived: false, createdAt: Date.now() - 3600000 * 2,
  },
  {
    id: "c6", colId: "col-4",
    title: "Initial project setup",
    desc: "Completed repo init and CI/CD",
    labels: ["green"],
    checklist: [
      { id: "ch13", text: "Repo created",        done: true },
      { id: "ch14", text: "CI/CD configured",    done: true },
    ],
    archived: false, createdAt: Date.now() - 86400000 * 7,
  },
  {
    id: "c7", colId: "col-1",
    title: "Write unit tests",
    desc: "", labels: [], checklist: [],
    archived: true, createdAt: Date.now() - 86400000 * 4,
  },
];

// ── localStorage helpers ──────────────────────────────────────────────────────
export function loadColumns() {
  try {
    const raw = localStorage.getItem("trello_cols");
    return raw ? JSON.parse(raw) : DEFAULT_COLUMNS;
  } catch { return DEFAULT_COLUMNS; }
}

export function saveColumns(cols) {
  try { localStorage.setItem("trello_cols", JSON.stringify(cols)); } catch {}
}

export function loadCards() {
  try {
    const raw = localStorage.getItem("trello_cards");
    return raw ? JSON.parse(raw) : DEFAULT_CARDS;
  } catch { return DEFAULT_CARDS; }
}

export function saveCards(cards) {
  try { localStorage.setItem("trello_cards", JSON.stringify(cards)); } catch {}
}

// ── checklist util ────────────────────────────────────────────────────────────
export function checklistProgress(checklist) {
  if (!checklist || !checklist.length) return null;
  const done = checklist.filter(c => c.done).length;
  return { done, total: checklist.length, pct: Math.round((done / checklist.length) * 100) };
}